export tag Story
	prop story
	<self>
		<span.score> story.points
		<span.title>
		if story.url && !story.url.startsWith('item?id=')
			<a href=story.url target="_blank" rel="noreferrer"> story.title
			<span.host> ` ({story.domain})`
		else
			<a route-to=`/item/{story.id}`> story.title
		<br />
		<span.meta>
			if story.type !== "job"
				"by " 
				<a route-to=`/user/{story.user}`> story.user
				" {story.time_ago} | "
				<a route-to=`/item/{story.id}`> `{story.comments_count ? " {story.comments_count} comments" : "discuss"}`
			else
				<a route-to=`/item/{story.id}`> story.time_ago
			if story.type !== "link"
				<span.label> story.type